<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click.native.stop="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="pb-4 pt-0" />
      <v-card-text class="pt-4 pb-2">
        <v-row class="mb-0 pb-0">
          <v-col class="py-0" cols="12" md="6" lg="4">
            <el-text-field
              label="Vardas"
              v-model="formData.name"
              :maxlength="200"
              required
            />
          </v-col>
          <v-col class="py-0" cols="12" md="6" lg="4">
            <el-text-field
              label="Pavardė"
              v-model="formData.lastname"
              :maxlength="200"
              required
            />
          </v-col>
          <v-col class="py-0" cols="12" md="6" lg="4">
            <el-text-field
              label="Pareigos"
              v-model="formData.duties"
              :maxlength="200"
              required
            />
          </v-col>
          <v-col class="py-0" cols="12" md="6" lg="4">
            <el-date-picker
              label="Galioja nuo"
              required
              v-model="formData.valid_from"
            />
          </v-col>
          <v-col class="py-0" cols="12" md="6" lg="4">
            <el-date-picker
              label="Galioja iki"
              :afterDate="formData.valid_from"
              v-model="formData.valid_to"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0" elevation="5">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-1"
            color="secondary"
            icon="atšaukti"
            title="Atšaukti"
            @click.native.stop="cancel()"
            :loading="modalloading"
          />
          <el-button
            title="Pridėti"
            :loading="modalloading"
            @click.native="confirmData()"
            color="primary"
            icon="išsaugoti"
          />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import errorNotifications from '@/mixins/errorNotifications'

export default {
  name: 'ModalAddConfirmPerson',
  mixins: [errorNotifications],
  props: {},
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      showModal: true,
      modalloading: false,
      formData: {},
    }
  },
  computed: {
    showTitle() {
      return this.$t('Pridėti asmenį')
    },
  },
  created() {},
  methods: {
    closeModal(update) {
      this.$emit('close-modal', update)
    },
    cancel() {
      this.closeModal()
    },
    submit() {
      this.confirmData()
    },
    confirmData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.saveData()
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    saveData() {
      this.modalloading = true
      let formData = this.formData
      let url = `authorizing-persons`
      this.$axios
        .post(url, formData)
        .then(() => {
          this.$root.$emit('DATA_OK_CODE', '000110')
          this.closeModal(true)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.modalloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
